<template>
  <v-container class="mx-1" fluid v-if="languageData.products">
      <v-col cols="12">
          <v-card :class="$vuetify.breakpoint.smAndUp ? 'px-10' : null" class="elevation-0">
                <v-form ref="productForm" v-model="validProductForm">
                    <p class="text-h5 mb-9">{{ languageData.products.productFormHead }}</p>
                    <v-row>
                        <v-col
                            :cols="$vuetify.breakpoint.mdAndUp ? 5 : 12">
                        <v-text-field
                            v-model="data.name"
                            :rules="[(v) => !!v || languageData.products.nameRequired]"
                            :label="languageData.products.productName"
                            outlined
                        ></v-text-field>
                        </v-col>
                        <v-col
                            :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
                        <v-text-field
                            v-model="data.price"
                            :label="languageData.products.price"
                            :rules="[(v) => !!v || languageData.products.priceRequired, v => ( v && v < 1000000000 ) || languageData.products.maxPrice]"
                            min="0" step="0.01"
                            type="number"
                            append-icon="euro"
                            outlined
                        ></v-text-field>
                        </v-col>
                        <v-col
                            :cols="$vuetify.breakpoint.mdAndUp ? 2 : 12">
                            <v-select
                                :label="languageData.products.uom"
                                v-model="data.uom"
                                :items="measureTypes"
                                :rules="[(v) => !!v || languageData.products.uomRequired]"
                                item-value="value"
                                item-text="name"
                                outlined
                                >
                            <template slot='selection' slot-scope='{ item }'>
                                {{ languageData.measureTypes[item.value] }}
                            </template>
                            <template slot='item' slot-scope='{ item }'>
                                {{ languageData.measureTypes[item.value] }}
                            </template>
                            </v-select>
                        </v-col>
                        <v-col
                            :cols="$vuetify.breakpoint.mdAndUp ? 2 : 12">
                            <v-select
                                :disabled="!showVat()"
                                :label="languageData.products.vat"
                                v-model="data.vat"
                                :items="showVat() ? vatData : []"
                                item-value="value"
                                item-text="label"
                                outlined
                                :rules="showVat() ? [(v)  => typeof v === 'number' || languageData.products.vatRequired] : []"
                            >
                            <template slot='selection' slot-scope='{ item }'>
                                {{ languageData.vatLabels[item.label] }}
                            </template>
                            <template slot='item' slot-scope='{ item }'>
                                {{ languageData.vatLabels[item.label] }}
                            </template>
                            </v-select>
                        </v-col>
                    </v-row>
                    <v-row justify="end" style="padding: 0px 12px !important">
                        <v-btn
                            class="button-shadow mb-5"
                            color="primary"
                            style="padding-left: 25px !important; padding-right: 25px !important"
                            height="55px"
                            :loading="saveProductIsFetching || updateProductIsFetching"
                            @click="saveProduct">{{ layout === 'add' ? languageData.products.saveProduct : languageData.products.updateProduct }}</v-btn>
                    </v-row>
                </v-form>
            </v-card>
        </v-col>
  </v-container>
</template>

<script type="text/javascript">
import measureTypes from "../../../../enums/measureTypes";
import {mapActions, mapState} from "vuex";
import eventBus from "../../../../event-bus/eventBus";
import handleFormError from "../../../../helpers/handleFormError";

 export default {
   name: "ProductForm",
   props: {
    layout: String,
    productData: Object
   },
   data() {
     return {
       data: {},
       measureTypes: measureTypes,
       isVatPayer: null,
       rules: {},
       validProductForm: false,
     }
   },
   methods: {
    ...mapActions("getVat", ["getVat"]),
    ...mapActions("storeProduct", ["storeProductRequest"]),
    ...mapActions("updateProduct", ["updateProductRequest"]),

    showVat() {
      return this.isVatPayer === 'true';
    },

    saveProduct() {
        this.data.language = localStorage.getItem("language");
        if (this.$refs.productForm) {
            this.$refs.productForm.resetValidation();
        }  
        this.rules = [];
        if(this.layout === "edit") {
            this.updateProductRequest(this.data);
        } else {
            if (!this.showVat()) {
                this.data.vat = 0;
            }
            this.storeProductRequest(this.data);
       }
    }
   },
   computed: {
    ...mapState("getVat", {
      vatData: state => state.vat
    }),
    ...mapState("storeProduct", {
        saveProductIsFetching: state => state.saveProductIsFetching,
    }),
    ...mapState("updateProduct", {
        updateProductIsFetching: state => state.updateProductIsFetching,
    }),
   },
   mounted() {
    this.getVat();
    eventBus.$on("saveProductFailure", (errorsData) => {
       this.rules = handleFormError(errorsData);
       if (this.$refs.productForm) {
        this.$refs.productForm.validate();
       }    
    });
    if (this.layout === 'edit' && this.productData) {
        this.data = this.productData;
        this.$refs.productForm.resetValidation();
    }
   },
   beforeMount() {
    this.isVatPayer = localStorage.getItem('companyIsVatPayer')
   }
 }
</script>